import React from 'react'
import { useIntl } from 'react-intl'
import withAuth from '../../../components/withAuth'
import LoanDocumentsContent from './LoanDocumentsContent'
import LoanPage from '../../../components/LoanPage'

const LoanDocuments = () => {
	const { formatMessage } = useIntl()
	return (
		<LoanPage
			page="documents"
			isFullWidth
			breadcrumbs={[
				{
					label: formatMessage({ id: 'breadcrumbs.documents' }),
					value: 'documents',
				},
			]}
		>
			<LoanDocumentsContent />
		</LoanPage>
	)
}

export default withAuth(LoanDocuments)
